import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import SEO from "../components/SEO";

const AuthLayout = () => {
  return (
    <>
      <SEO /> 
      <Box display="flex" flexDirection="column" minHeight="100vh">
        <Outlet />
      </Box>
    </>
  );
};

export default AuthLayout;